import { Grid } from "@material-ui/core";
import React from "react";

export const Row = ({ children }: { children: React.ReactNode }) => {
  return (
    <Grid container spacing={3}>
      {children}
    </Grid>
  );
};
